<template>
    <b-modal v-model="showModal" @hidden="fecharModal" ref="modalAutorizacaoFornecedor" size="xl" hide-footer
        :title="prefix + title">
        <ConsultarCarona :prefix="prefix" :ata="ata"></ConsultarCarona>

    </b-modal>
</template>

<script>

import ConsultarCarona from './ConsultarCarona.vue'

export default {
    components: {
        ConsultarCarona
    },
    props: {
        ata: {
            type: Number,
            default: null
        },
        prefix: {
            type: String,
            default: "",
        }
    },
    data() {
        return {
            title: "Consultar Carona",
            showModal: true
        }
    },
    computed: {
    },
    methods: {
        fecharModal() {
            this.$emit('close')
        }
    },
    async beforeMount() {
    }
}
</script>
